export const isUnique = (arr) => new Set(arr).size === arr?.length;
